<template>
  <b-card no-body>
    <b-card-body class="d-flex justify-content-between align-items-center">
      <div class="truncate">
        <h2 class="mb-25 font-weight-bolder">
          Exportar Datos
        </h2>
        <span>Aplica filtros para tú exportación</span>
      </div>
      <b-avatar
        :variant="`light-${color}`"
        size="45"
      >
        <b-button
          :variant="`light-${color}`"
          :disabled="isLoading"
          @click="exportData"
        >
          <b-spinner v-if="isLoading"/>
          <feather-icon
            v-else
            size="21"
            :icon="icon"
          />
        </b-button>
      </b-avatar>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BButton, BCard, BCardBody, BAvatar, BSpinner,
} from 'bootstrap-vue'

import PrebecariosService from '@/services/PrebecariosService'

export default {
  components: {
    BCard,
    BButton,
    BCardBody,
    BAvatar,
    BSpinner,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: 'primary',
    },
    filter: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  methods: {
    exportData() {
      const vm = this
      vm.isLoading = true
      PrebecariosService.exportData(vm.filter)
        .then(response => {
          const { status } = response
          if (status === 200) {
            const blob = new Blob([response.data], {
              type: response.headers['content-type'],
            })
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = 'export-file.xlsx'
            link.click()
          }
        })
        .finally(() => {
          vm.isLoading = false
        })
    },
  },
}
</script>
